import { render, staticRenderFns } from "./EditAbsence.vue?vue&type=template&id=a74d0d96&"
import script from "./EditAbsence.vue?vue&type=script&lang=js&"
export * from "./EditAbsence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports